import AnimatedNumber from '../components/AnimatedNumber.jsx';
import Icon from '../components/Icon.jsx';

const sourceUrl = 'https://www.who.int/news-room/fact-sheets/detail/disability-and-health';

export default function StatisticsSlide({ active }) {
  return (
    <section className="slide-content statistics-slide">
      <div className="statistics-background-lines" aria-hidden="true">
        <svg viewBox="0 0 1920 1080" preserveAspectRatio="none">
          <defs>
            <linearGradient id="statsWaveBlue" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="rgba(26,149,211,0)" />
              <stop offset="18%" stopColor="rgba(26,149,211,0.34)" />
              <stop offset="52%" stopColor="rgba(70,180,232,0.78)" />
              <stop offset="82%" stopColor="rgba(26,149,211,0.30)" />
              <stop offset="100%" stopColor="rgba(26,149,211,0)" />
            </linearGradient>
            <linearGradient id="statsWaveSand" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="rgba(183,169,150,0)" />
              <stop offset="22%" stopColor="rgba(183,169,150,0.20)" />
              <stop offset="54%" stopColor="rgba(210,198,181,0.44)" />
              <stop offset="100%" stopColor="rgba(183,169,150,0)" />
            </linearGradient>
            <linearGradient id="statsWaveWhite" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="rgba(255,255,255,0)" />
              <stop offset="28%" stopColor="rgba(255,255,255,0.12)" />
              <stop offset="56%" stopColor="rgba(255,255,255,0.26)" />
              <stop offset="82%" stopColor="rgba(255,255,255,0.12)" />
              <stop offset="100%" stopColor="rgba(255,255,255,0)" />
            </linearGradient>
          </defs>

          <g className="stats-wave-group group-a">
            <path className="stats-wave wave-main" d="M-80 730C110 700 220 752 370 672C528 586 632 450 788 486C944 522 1013 732 1180 738C1342 744 1460 486 1640 454C1782 428 1880 486 2010 530" />
            <path className="stats-wave wave-main-soft" d="M-100 740C140 700 260 770 396 700C552 620 664 470 806 500C958 530 1040 750 1206 752C1388 754 1490 498 1668 466C1820 442 1920 506 2042 534" />
          </g>

          <g className="stats-wave-group group-b">
            <path className="stats-wave wave-dashed" d="M-110 808C64 866 230 826 392 736C560 642 704 564 892 594C1068 620 1180 754 1352 764C1526 774 1686 660 2026 662" />
          </g>

          <g className="stats-wave-group group-c">
            <path className="stats-wave wave-light" d="M-40 512C112 420 250 382 404 440C558 498 638 646 782 668C960 696 1088 510 1232 406C1382 296 1554 284 1960 346" />
            <path className="stats-wave wave-sand" d="M40 532C192 438 296 404 432 452C566 498 658 656 806 692C972 730 1070 550 1214 450C1382 330 1566 320 1892 366" />
          </g>

          <g className="stats-wave-group group-d">
            <path className="stats-wave wave-thread" d="M-120 250C70 218 178 180 334 212C520 250 640 422 780 464C920 506 1028 442 1176 348C1360 230 1578 180 2000 192" />
          </g>
        </svg>
      </div>

      <div className="template-nav">
        <b>WARDIERE INC.</b>
        <span>Home</span><i /><span>About</span><i /><span>Service</span>
      </div>

      <div
        style={{
          position: 'relative',
          zIndex: 3,
          display: 'grid',
          gridTemplateRows: 'auto 1fr',
          alignContent: 'start',
          gap: '26px',
          minHeight: '100%',
          paddingTop: '34px',
          paddingBottom: '26px',
        }}
      >
        <div
          className="statistics-heading reveal-stack"
          style={{
            alignSelf: 'start',
            maxWidth: '100%',
          }}
        >
          <div className="eyebrow">
            <Icon name="pulse" />
            Statistics
          </div>
          <h2 style={{ marginTop: '18px' }}>Statistics</h2>
        </div>

        <div
          className="statistics-cards"
          style={{
            gridTemplateColumns: 'minmax(0, 0.88fr) minmax(0, 1.12fr)',
            alignItems: 'stretch',
            alignSelf: 'stretch',
            width: '100%',
            marginTop: '8px',
          }}
        >
          <article
            className="statistic-panel"
            style={{
              minHeight: '430px',
              padding: '40px 34px 30px',
              justifyContent: 'space-between',
            }}
          >
            <span className="stat-index">01</span>
            <div>
              <AnimatedNumber value={16} suffix="%" active={active} className="stat-number" />
              <h3 style={{ marginTop: '24px' }}>POD</h3>
            </div>
            <a href={sourceUrl} target="_blank" rel="noreferrer">
              {sourceUrl}
            </a>
          </article>

          <article
            className="statistic-panel statistic-panel-wide"
            style={{
              minHeight: '430px',
              padding: '40px 34px 30px',
              justifyContent: 'space-between',
            }}
          >
            <span className="stat-index">02</span>
            <div>
              <AnimatedNumber value={30} suffix="%" active={active} className="stat-number" />
              <h3 style={{ marginTop: '24px', maxWidth: '16ch' }}>HAS A DEGREE OF HEARING LOSS</h3>
            </div>
            <a href={sourceUrl} target="_blank" rel="noreferrer">
              {sourceUrl}
            </a>
          </article>
        </div>
      </div>
    </section>
  );
}
